import { extend } from 'flarum/common/extend';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import LinkButton from 'flarum/common/components/LinkButton';
export default function addSidebarNav() {
  extend(IndexSidebar.prototype, 'navItems', function (items) {
    if (app.forum.attribute('blogAddSidebarNav') && app.forum.attribute('blogAddSidebarNav') !== '0') {
      items.add('blog', m(LinkButton, {
        icon: "fas fa-comment",
        href: app.route('blog')
      }, app.translator.trans('v17development-flarum-blog.forum.blog')), 15);
    }
    return items;
  });
}
flarum.reg.add('v17development-blog', 'forum/utils/addSidebarNav', addSidebarNav);